import apiRequest from '../api-request';

export default async function apiCreateProjectScenario(project, scenario) {
    try {
        const response = await apiRequest('create_project_scenario', {project, scenario});
        return response.data.status === 'SUCCESS' ? response.data.scenariosList : false;
    } catch (e) {
        console.error('There was an error retrieving the project scenario.', e);
        return false;
    }
}
